import '@aws-amplify/ui-react/styles.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports';
import App from './App';

Amplify.configure(awsmobile);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);